import { useState, useEffect } from 'react'
import { CheckCircle2, Loader2 } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

interface DiscoveryItemProps {
  icon: LucideIcon
  label: string
  children: React.ReactNode
  delay?: number
}

export default function DiscoveryItem({ icon: Icon, label, children, delay = 0 }: DiscoveryItemProps) {
  const [visible, setVisible] = useState(false)
  const [complete, setComplete] = useState(false)

  useEffect(() => {
    const showTimer = setTimeout(() => setVisible(true), delay)
    const completeTimer = setTimeout(() => setComplete(true), delay + 400)
    return () => { clearTimeout(showTimer); clearTimeout(completeTimer) }
  }, [delay])

  if (!visible) return null

  return (
    <div className="flex items-start gap-3 animate-in fade-in slide-in-from-bottom-2 duration-300">
      <div className="flex-shrink-0 w-8 h-8 rounded-lg bg-muted flex items-center justify-center mt-0.5">
        <Icon className="h-4 w-4 text-muted-foreground" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 mb-1">
          <span className="text-xs font-medium uppercase tracking-wide text-muted-foreground">{label}</span>
          {complete ? (
            <CheckCircle2 className="h-3.5 w-3.5 text-green-500 animate-in zoom-in duration-200" />
          ) : (
            <Loader2 className="h-3.5 w-3.5 text-muted-foreground animate-spin" />
          )}
        </div>
        <div className="text-sm">{children}</div>
      </div>
    </div>
  )
}
